import { MerchantService } from "@/services/appointment/type";
import { CustomerInfo } from "@/services/customer/type";
import { create } from "zustand";
import { devtools, persist } from "zustand/middleware";

export type SetDatePayload = {
  selectedDate: Date;
};

export type SetCustomerPayload = {
  selectCustomer: CustomerInfo;
};

export type SetMerchantServicePayload = {
  selectService: MerchantService;
};

export type SetSelectedAppointmentDatePayload = {
  selectedAppointmentDate: Date;
};

export type SetSelectedAppointmentTimePayload = {
  selectedAppointmentTime: string[];
};

export type SetMerchantServiceFilterPayload = {
  merchantServiceFilters?: MerchantService[];
};

export type SetShowTypePayload = {
  showType?: "daily" | "list";
};

interface ScheduleState {
  selectedDate: Date;
  showType: "daily" | "list";
  selectCustomer?: CustomerInfo;
  selectService?: MerchantService;
  selectedAppointmentDate: Date;
  selectedAppointmentTime?: string[];
  merchantServiceFilters?: MerchantService[];
  setDate: (command: SetDatePayload) => void;
  setCustomer: (command: SetCustomerPayload) => void;
  setMerchantService: (command: SetMerchantServicePayload) => void;
  setMerchantServiceFilters: (command: SetMerchantServiceFilterPayload) => void;
  setSelectedAppointmentDate: (
    command: SetSelectedAppointmentDatePayload
  ) => void;
  setSelectedAppointmentTime: (
    command: SetSelectedAppointmentTimePayload
  ) => void;
  setShowType: (command: SetShowTypePayload) => void;
}

const useScheduleStore = create<ScheduleState>()(
  devtools(
    persist(
      (set) => ({
        selectedDate: new Date(),
        selectCustomer: undefined,
        selectedAppointmentDate: new Date(),
        showType: "daily",
        setDate: (command) =>
          set((state) => ({
            ...state,
            ...command,
          })),
        setCustomer: (command) =>
          set((state) => ({
            ...state,
            ...command,
          })),
        setMerchantService: (command) =>
          set((state) => ({
            ...state,
            ...command,
          })),
        setSelectedAppointmentDate: (command) =>
          set((state) => ({
            ...state,
            ...command,
          })),
        setSelectedAppointmentTime: (command) =>
          set((state) => ({
            ...state,
            ...command,
          })),
        setMerchantServiceFilters: (command) =>
          set((state) => ({
            ...state,
            ...command,
          })),
        setShowType: (command) =>
          set((state) => ({
            ...state,
            ...command,
          })),
      }),
      { name: "ScheduleState" }
    )
  )
);

export default useScheduleStore;
